export default {
  categories: 'Categorias',
  segments: 'Segmentos',
  businesses: 'Empresas',
  active: 'Ativo',
  inactive: 'Inativo',
  noBusinessesCreated: 'Nenhuma empresa foi criada',
  newBusiness: 'Novos Negócios',
  editBusiness: 'Editar negócios',
  businessUrl: 'URL de negócios',
  segment: 'Segmento',
  insertExtraDataName: 'Insira nome de dados extras',
  insertExtraDataValues: 'Insira valores extras de dados',
  delete: 'Excluir',
  addExtraData: 'Adicionar dados extras',
  businessSuccessfullyCreated: 'Negócios criados com sucesso',
  businessSuccessfullyEdited: 'Empresa editada com sucesso',
  addNewBusiness: 'Adicionar novos negócios',
  uploadPhoto: 'Carregar foto',
  doYouWantToDeleteThisContact: 'Deseja excluir esse contato?',
  deleteContact: 'Excluir contato',
  contactSuccessfullyDeleted: 'Contato excluído com sucesso',
  doYouWantToDeleteThisBusiness: 'Quer excluir esse negócio?',
  deleteBusiness: 'Excluir negócios',
  businessSuccessfullyDeleted: 'Negócios excluídos com sucesso',
  errorLoadingTheBusiness: 'Houve um erro carregando o negócio',
  addContact: 'Adicionar contato',
  nameOfTheBusiness: 'Nome do negócio',
  noCategories: 'Sem categorias',
  noLocation: 'Sem localização',
  noAddress: 'Sem endereço',
  noSegment: 'Sem segmento',
  contactSuccessfullyAdded: 'Contato adicionado com sucesso',
  contacts: 'Contatos',
  noRoles: 'Sem papéis',
  loadingBusinessContacts: 'Carregando contatos de negócios',
  noBusinessContacts: 'Este negócio não tem contatos'
}
